import { buildApiUrl } from "./apiConfig";
import { disconnectTeamChat } from "../polaris-components/team-chat/teamChatSocket";

/**
 * Full logout: clear cookies/storage, redirect to login.
 */
export async function performLogout(): Promise<void> {
    disconnectTeamChat();
    try {
        // Call backend FIRST to clear HTTP-only cookies (jwt, stripe_mid, stripe_sid)
        await fetch(buildApiUrl("api/auth/logout"), {
            method: "POST",
            credentials: "include",
            headers: { Accept: "application/json" },
        });
    } catch (error) {
        console.error("Logout request failed:", error);
    }

    localStorage.clear();
    sessionStorage.clear();

    try {
        const allCookies = document.cookie.split(";");
        allCookies.forEach((cookie) => {
            const cookieName = cookie.split("=")[0].trim();
            const domain = window.location.hostname;

            document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
            document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
            document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${domain};`;
        });
    } catch (error) {
        console.error("Failed to clear non-HTTP-only cookies:", error);
    }

    window.location.href = "/login";
}
